import script from "./treeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./treeSelect.vue?vue&type=script&setup=true&lang=js"

import "./treeSelect.vue?vue&type=style&index=0&id=9a7ef800&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a7ef800"]])

export default __exports__